import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { DataBlocks } from 'components';

import {
  ACCOUNT_EDIT_POPUP_KEY,
  ACCOUNT_GROUP_EDIT_POPUP_KEY,
  CONTRACT_EDIT_POPUP_KEY,
  ASSOCIATE_ACCOUNT_POPUP_KEY,
  ASSOCIATE_MASTER_ACCOUNT_POPUP_KEY,
  CONFIRMATION_DELETING_POPUP_KEY,
  CONFIRMATION_MASTER_DELETING_POPUP_KEY,
} from './constants';

import OfferPopup from '../../components/OfferPopup';

import MasterAccounts from './components/MasterAccounts';
import PhoneNumberConfig from './components/PhoneNumberConfig';
import AssociatedAccounts from './components/AssociatedAccounts';
import AssociateAccountPopup from './components/AssociateAccountPopup';

import {
  fetchInitialData,
  updateMasterAccountsProhibition,
  toggleAssociateAccountPopup,
  createAccountLink,
  handleCloseAssociateAccountPopup,
  toggleAssociateMasterAccountPopup,
  handleCloseAssociateMasterAccountPopup,
  createMasterAccountLink,
  deleteAccountLink,
  deleteMasterAccountLink,
  cancelLinkageRequest,
  cancelLinkageRequestForMaster,
  updateLinkageRequest,
  updateLinkageRequestForMaster,
  toggleOfferPopup,
  updateAssociatedCtnAccount,
  updateAssociatedBanAccount,
  updateAssociatedBenAccount,
  updateMasterNickName,
  fetchAssociatedAccountsData,
  fetchMasterAccountsData,
  toggleAccountEditPopup,
  toggleAccountGroupEditPopup,
  toggleContractEditPopup,
  toggleConfirmationDeletingPopup,
  toggleConfirmationMasterDeletingPopup,
  fetchPinPuk,
} from './actions';

class NumberManagement extends PureComponent {
  componentDidMount() {
    this.props.actions.fetchInitialData();
  }

  render() {
    const {
      actions,
      masterAccounts,
      associatedAccounts,
      isMasterAccountsEnabled,
      isAssociateAccountPopupOpened,
      isAssociateMasterAccountPopupOpened,
      masterLogin,
      nickName,
      accountLinkingStatus,
      isAccountLinkDeleting,
      isMasterAccountLinkDeleting,
      isMasterAccountsProhibitionUpdating,
      isAccountLinkCanceling,
      linkageRequests,
      offer,
      isOfferPopupOpened,
      loginUserTypes,
      isAssociatedAccountUpdating,
      isMasterNickNameUpdating,
      associatedAccountsError,
      masterAccountsError,
      isAccountEditPopupOpened,
      isAccountGroupEditPopupOpened,
      isContractEditPopupOpened,
      isConfirmationDeletingPopupOpened,
      isConfirmationMaserDeletingPopupOpened,
      pinPukFetchingError,
      isPinPukFetching,
      pinPuk,
    } = this.props;

    return (
      <DataBlocks.Container>
        <PhoneNumberConfig
          masterLogin={masterLogin}
          nickName={nickName}
          isMasterNickNameUpdating={isMasterNickNameUpdating}
          updateMasterNickName={actions.updateMasterNickName}
          fetchPinPuk={actions.fetchPinPuk}
          pinPukFetchingError={pinPukFetchingError}
          isPinPukFetching={isPinPukFetching}
          pinPuk={pinPuk}
        />
        <AssociatedAccounts
          {...associatedAccounts}
          linkAccount={() => actions.toggleAssociateAccountPopup(true)}
          deleteAccountLink={actions.deleteAccountLink}
          isAccountLinkDeleting={isAccountLinkDeleting}
          isAssociatedAccountUpdating={isAssociatedAccountUpdating}
          incomingLinkageRequests={linkageRequests.incomingLinkageRequests}
          outgoingLinkageRequests={linkageRequests.outgoingLinkageRequests}
          cancelRequest={actions.cancelLinkageRequest}
          updateLinkageRequest={actions.updateLinkageRequest}
          updateAssociatedCtnAccount={actions.updateAssociatedCtnAccount}
          updateAssociatedBanAccount={actions.updateAssociatedBanAccount}
          updateAssociatedBenAccount={actions.updateAssociatedBenAccount}
          error={associatedAccountsError}
          isAccountEditPopupOpened={isAccountEditPopupOpened}
          isAccountGroupEditPopupOpened={isAccountGroupEditPopupOpened}
          isContractEditPopupOpened={isContractEditPopupOpened}
          isConfirmationDeletingPopupOpened={isConfirmationDeletingPopupOpened}
          toggleAccountEditPopup={actions.toggleAccountEditPopup}
          toggleAccountGroupEditPopup={actions.toggleAccountGroupEditPopup}
          toggleContractEditPopup={actions.toggleContractEditPopup}
          toggleConfirmationDeletingPopup={actions.toggleConfirmationDeletingPopup}
          refreshAction={actions.fetchAssociatedAccountsData}
        />
        <MasterAccounts
          accounts={masterAccounts}
          isEnabled={isMasterAccountsEnabled}
          updateProhibition={actions.updateMasterAccountsProhibition}
          isProhibitionUpdating={isMasterAccountsProhibitionUpdating}
          linkMasterAccount={() => actions.toggleAssociateMasterAccountPopup(true)}
          deleteMasterAccountLink={actions.deleteMasterAccountLink}
          isMasterAccountLinkDeleting={isMasterAccountLinkDeleting}
          incomingLinkageRequests={linkageRequests.incomingLinkageRequestsForMaster}
          outgoingLinkageRequests={linkageRequests.outgoingLinkageRequestsForMaster}
          cancelRequest={actions.cancelLinkageRequestForMaster}
          updateLinkageRequest={actions.updateLinkageRequestForMaster}
          error={masterAccountsError}
          isConfirmationDeletingPopupOpened={isConfirmationMaserDeletingPopupOpened}
          toggleConfirmationDeletingPopup={actions.toggleConfirmationMasterDeletingPopup}
          refreshAction={actions.fetchMasterAccountsData}
        />
        <AssociateAccountPopup
          withPassword
          isOpened={isAssociateAccountPopupOpened}
          onClose={actions.handleCloseAssociateAccountPopup}
          onCreateLink={actions.createAccountLink}
          accountLinkingStatus={accountLinkingStatus}
          isAccountLinkCanceling={isAccountLinkCanceling}
          showOffer={() => actions.toggleOfferPopup(true)}
          userTypes={loginUserTypes}
        />
        <AssociateAccountPopup
          isOpened={isAssociateMasterAccountPopupOpened}
          onClose={actions.handleCloseAssociateMasterAccountPopup}
          onCreateLink={actions.createMasterAccountLink}
          accountLinkingStatus={accountLinkingStatus}
          isAccountLinkCanceling={isAccountLinkCanceling}
          userTypes={loginUserTypes}
        />
        <OfferPopup
          offerText={offer}
          isOpened={isOfferPopupOpened}
          onClose={() => actions.toggleOfferPopup(false)}
        />
      </DataBlocks.Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    associatedAccountsError: state.settings.numberManagement.associatedAccountsError,
    masterAccountsError: state.settings.numberManagement.masterAccountsError,
    masterAccounts: state.settings.numberManagement.masterAccounts,
    pinPuk: state.settings.numberManagement.pinPuk,
    pinPukFetchingError: state.settings.numberManagement.pinPukFetchingError,
    isPinPukFetching: state.settings.numberManagement.isPinPukFetching,
    associatedAccounts: state.settings.numberManagement.associatedAccounts,
    isMasterAccountsEnabled: state.settings.numberManagement.isMasterAccountsEnabled,
    isMasterAccountsProhibitionUpdating:
      state.settings.numberManagement.isMasterAccountsProhibitionUpdating,
    accountLinkingStatus: state.settings.numberManagement.accountLinkingStatus,
    isAccountLinkDeleting: state.settings.numberManagement.isAccountLinkDeleting,
    isMasterAccountLinkDeleting: state.settings.numberManagement.isMasterAccountLinkDeleting,
    isAccountLinkCanceling: state.settings.numberManagement.isAccountLinkCanceling,
    linkageRequests: state.settings.numberManagement.linkageRequests,
    offer: state.settings.numberManagement.offer,
    isOfferPopupOpened: state.settings.numberManagement.isOfferPopupOpened,
    loginUserTypes: state.settings.numberManagement.loginUserTypes,
    isAssociatedAccountUpdating: state.settings.numberManagement.isAssociatedAccountUpdating,
    masterLogin: state.application.settings.masterLogin,
    nickName: state.application.settings.nickname,
    isMasterNickNameUpdating: state.application.isMasterNickNameUpdating,
    isAccountEditPopupOpened: state.application.popup === ACCOUNT_EDIT_POPUP_KEY,
    isAccountGroupEditPopupOpened: state.application.popup === ACCOUNT_GROUP_EDIT_POPUP_KEY,
    isContractEditPopupOpened: state.application.popup === CONTRACT_EDIT_POPUP_KEY,
    isAssociateAccountPopupOpened: state.application.popup === ASSOCIATE_ACCOUNT_POPUP_KEY,
    isAssociateMasterAccountPopupOpened:
      state.application.popup === ASSOCIATE_MASTER_ACCOUNT_POPUP_KEY,
    isConfirmationDeletingPopupOpened: state.application.popup === CONFIRMATION_DELETING_POPUP_KEY,
    isConfirmationMaserDeletingPopupOpened:
      state.application.popup === CONFIRMATION_MASTER_DELETING_POPUP_KEY,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchInitialData,
      updateMasterAccountsProhibition,
      toggleAssociateAccountPopup,
      createAccountLink,
      handleCloseAssociateAccountPopup,
      toggleAssociateMasterAccountPopup,
      handleCloseAssociateMasterAccountPopup,
      createMasterAccountLink,
      deleteAccountLink,
      deleteMasterAccountLink,
      cancelLinkageRequest,
      cancelLinkageRequestForMaster,
      updateLinkageRequest,
      updateLinkageRequestForMaster,
      toggleOfferPopup,
      updateAssociatedCtnAccount,
      updateAssociatedBanAccount,
      updateAssociatedBenAccount,
      updateMasterNickName,
      fetchAssociatedAccountsData,
      fetchMasterAccountsData,
      toggleAccountEditPopup,
      toggleAccountGroupEditPopup,
      toggleContractEditPopup,
      toggleConfirmationDeletingPopup,
      toggleConfirmationMasterDeletingPopup,
      fetchPinPuk,
    }, dispatch),
  };
}

NumberManagement.propTypes = {
  actions: PropTypes.object,
  associatedAccountsError: PropTypes.string,
  masterAccountsError: PropTypes.string,
  masterAccounts: PropTypes.array,
  associatedAccounts: PropTypes.object,
  isMasterAccountsEnabled: PropTypes.bool,
  isAssociateAccountPopupOpened: PropTypes.bool,
  isAssociateMasterAccountPopupOpened: PropTypes.bool,
  masterLogin: PropTypes.string,
  nickName: PropTypes.string,
  accountLinkingStatus: PropTypes.object,
  isAccountLinkDeleting: PropTypes.bool,
  isMasterAccountLinkDeleting: PropTypes.bool,
  isMasterAccountsProhibitionUpdating: PropTypes.bool,
  isAccountLinkCanceling: PropTypes.bool,
  isAssociatedAccountUpdating: PropTypes.bool,
  linkageRequests: PropTypes.object,
  offer: PropTypes.string,
  isOfferPopupOpened: PropTypes.bool,
  loginUserTypes: PropTypes.array,
  isMasterNickNameUpdating: PropTypes.bool,
  isAccountEditPopupOpened: PropTypes.bool,
  isAccountGroupEditPopupOpened: PropTypes.bool,
  isContractEditPopupOpened: PropTypes.bool,
  isConfirmationDeletingPopupOpened: PropTypes.bool,
  isConfirmationMaserDeletingPopupOpened: PropTypes.bool,
  pinPukFetchingError: PropTypes.string,
  isPinPukFetching: PropTypes.bool,
  pinPuk: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(NumberManagement);
